import { render, staticRenderFns } from "./AddStudent.vue?vue&type=template&id=948e1afa&scoped=true&"
import script from "./AddStudent.vue?vue&type=script&lang=js&"
export * from "./AddStudent.vue?vue&type=script&lang=js&"
import style0 from "./AddStudent.vue?vue&type=style&index=0&id=948e1afa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948e1afa",
  null
  
)

export default component.exports